export default __webpack_public_path__ + "static/media/404.a2465c47.jpeg";